import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import ExpiryBarChart from '../BacklogInsights/Components/ExpiryBarChart';
import { get_po_backlog_state } from '../../redux/po_backlog/backlog.selector';
import { useDispatch, useSelector } from 'react-redux';
import { load_po_from_backend } from '../../redux/po_backlog/po.action';
import AnalystMatrix from './components/AnalystMatrix/AnalystMatrix';
import MachineMatrix from './components/MachineMatrix/MachineMatrix';
import ContainedButton from '../../common/components/Buttons/ContainedButton';
import { load_intm_backlog_from_backend } from '../../redux/po_backlog/backlog.action';
import { generate_schedule_action } from '../../redux/app/app.actions';
import { useNavigate } from 'react-router';
import { v4 } from "uuid";
import { get_auth_user_data } from '../../redux/auth/auth.selectors';
// import PaginatedDataGrid from '../../common/components/Table/PaginatedDataGrid';
import AllBacklogs from './components/BacklogTable/AllBacklogs';
import AllSampleStatusSummary from './components/SampleStatusSummary/AllSampleStatusSummary';
import AllPos from './components/PoTable/AllPos';
import axiosInstance from '../../http-common';
import { getScheduleStatus } from '../Output/utils/helpers';
import { mixpanelTrackButton } from '../../mixPanelFunctions/mixPanelFunctions';

const HomePage = () => {
  const [userIsActive,] = useState(true);

  const [hidden_fields, set_hidden_fields] = useState({
    open_po: [],
    sample_status: []
  });

  const [scheduleStatus, setScheduleStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getScheduleStatus(setScheduleStatus, setLoading);
  }, []);

  // Function to fetch backlog data
  const fetchData = async () => {
    if (userIsActive) {
      // Your code to fetch the backlog data
      dispatch(load_po_from_backend(state));
      // dispatch(handle_intm_backlog_upload());
      dispatch(load_intm_backlog_from_backend());
      const response = await axiosInstance.get(`/v1/qc/get_hidden_fields`);
      const result = await response.data;
      if (result?.status === "success") {
        const updated_hidden_fields = result.data;
        set_hidden_fields(() => ({
          open_po: updated_hidden_fields.open_po,
          sample_status: updated_hidden_fields.sample_status,
        }));
      }
    }
  };
  // const navigate = useNavigate();

  const dispatch = useDispatch();
  const state = useSelector(get_po_backlog_state);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigate = useNavigate();

  const user = useSelector(get_auth_user_data);

  const handle_generate_schedule = () => {
    const form_data = new FormData();
    // form_data.append("client_id", "sunpharma_paonta_sahib");
    form_data.append("client_id", user?.selected_plant || "sunpharma_paonta_sahib");
    form_data.append("uuid", v4());
    form_data.append("user", user?.name || "Planner");
    form_data.append("qc_schedule_id", v4());
    form_data.append("schedule_name", `${user?.name || "planner"}_QC_${new Date().toDateString()}`);
    form_data.append("sla", 1);
    form_data.append("sample_tested_per_week", 1);
    dispatch(generate_schedule_action({ endpoint: "v1/qc_schedule/", navigate, form_data }));
    mixpanelTrackButton("home","generate schedule")
  };

  return (
    <div>
      <Box className="m-2 rounded-t-md grid grid-cols-3 gap-4">
        <Box className="col-span-3">
          <Box className="grid grid-cols-3 gap-4">
            <AllSampleStatusSummary />
            <Box className="col-span-3 sm:col-span-3 w-full">
              {/* Approaching SLA Target Completion Date Chart & Material Type Wise Sample Status */}
              {/* {
                intm_backlog_insights && intm_backlog_insights.daywise_sampling_receive_rate_histogram &&
                <ExpiryBarChart
                  series={intm_backlog_insights.daywise_sampling_receive_rate_histogram.series}
                  categories={intm_backlog_insights.daywise_sampling_receive_rate_histogram.categories}
                  // colors={intm_backlog_insights.daywise_sampling_receive_rate_histogram.colors}
                  x_axis_title="Dates"
                  y_axis_title="Samples Received"
                />
              } */}
              <ExpiryBarChart
              />
            </Box>
          </Box>
        </Box>
        <Box className="col-span-3" sx={{
          p: 3
        }}>
          <Typography variant="h4" gutterBottom align="left">
            Sample Status
          </Typography>
          <AllBacklogs hidden_fields={hidden_fields.sample_status} />
        </Box>
        {/* Open PO */}
        <Box className="col-span-3" sx={{ p: 3 }}>
          <Typography variant="h4" gutterBottom align="left">Open PO</Typography>
          <AllPos hidden_fields={hidden_fields.open_po} />
        </Box>
        <Box className="col-span-3 grid grid-cols-5 gap-4" sx={{ p: 3 }}>
          <Box className="col-span-4 md:col-span-5">
            <AnalystMatrix />
          </Box>
          <Box className="col-span-4 md:col-span-5">
            <MachineMatrix />
          </Box>
        </Box>
        <Box className="col-span-3 flex justify-center items-center">
          {
            <ContainedButton loading={loading} onClick={handle_generate_schedule} disabled={scheduleStatus !== "current"} >Generate Schedule</ContainedButton>
          }
        </Box>
      </Box>
    </div>
  );
};

export default HomePage;